/* eslint react/prop-types: 0 */
/* eslint react/no-multi-comp: 0 */
/* eslint react/display-name: 0 */
import React from 'react';
import TextCell from 's1-ui/sovos-table/components/TextCell';
import CurrencyCell from 's1-ui/sovos-table/components/CurrencyCell';
import { addDashIfZero, formatCurrency } from 'shared/helpers/dataFormatHelper';

const columns = [
  {
    title: 'Invoice',
    id: 1,
    style: {
      width: 100,
      flexShrink: 0
    },
    component: ({ content }) =>
      content.invoice !== undefined
      && content.invoice !== null
      &&  <TextCell>{ content.invoice }</TextCell>
  },
  {
    title: 'Date',
    id: 2,
    style: {
      width: 110,
      flexShrink: 0
    },
    component: ({ content }) =>
      content.date !== undefined
      && content.date !== null
      && <TextCell>{ content.date }</TextCell>
  },
  {
    title: 'Vendor',
    id: 3,
    type: 'greedy',
    component: ({ content }) =>
      content.vendorName !== undefined
      && content.vendorName !== null
      && <TextCell>{ content.vendorName }</TextCell>
  },
  {
    title: 'Gross',
    id: 4,
    type: 'no-wrap',
    component: ({ content }) =>
      content.grossAmount !== undefined
      && content.grossAmount !== null
        ? <CurrencyCell formatCurrency={ formatCurrency } value={ content.grossAmount }/>
        : `-`
  },
  {
    title: 'Vendor Tax',
    id: 5,
    type: 'no-wrap',
    component: ({ content }) =>
      content.vendorTax !== undefined
      && content.vendorTax !== null
      && <CurrencyCell formatCurrency={ formatCurrency } value={ content.vendorTax } />
  },
  {
    title: 'Sovos Tax',
    id: 6,
    type: 'no-wrap',
    component: ({ content }) =>
      content.calculatedTax !== undefined
      && content.calculatedTax !== null
      && <CurrencyCell formatCurrency={ addDashIfZero } value={ content.calculatedTax } />
  },
  {
    title: '$ Var',
    id: 7,
    type: 'no-wrap',
    component: ({ content }) =>
      content.dollarVariance !== undefined
      && content.dollarVariance !== null
      && <CurrencyCell formatCurrency={ addDashIfZero } value={ content.dollarVariance } />
  },
  {
    title: '% Var',
    id: 8,
    style: {
      width: 100,
      flexShrink: 0
    },
    component: ({ content }) =>
      content.percentVariance !== undefined
      && content.percentVariance !== null
      && <TextCell>{ `${ content.percentVariance }%` }</TextCell>
  },
  {
    title: 'Batch Name',
    id: 9,
    type: 'greedy',
    component: ({ content }) =>
      content.batchName !== undefined
      && content.batchName !== null
      && <TextCell>{ `${ content.batchName !== null ? content.batchName : `-` }` }</TextCell>
  },
  {
    title: 'Business Unit',
    id: 10,
    style: {
      width: 100,
      flexShrink: 0
    },
    component: ({ content }) =>
      content.businessUnit !== undefined
      && content.businessUnit !== null
      && <TextCell>{ `${ content.businessUnit }` }</TextCell>
  },
  {
    title: 'Company',
    id: 11,
    style: {
      width: 100,
      flexShrink: 0
    },
    component: ({ content }) =>
      content.company !== undefined
      && content.company !== null
      && <TextCell>{ `${ content.company }` }</TextCell>
  },
  {
    title: 'Document Number',
    id: 12,
    style: {
      width: 100,
      flexShrink: 0
    },
    component: ({ content }) =>
      content.documentNumber !== undefined
      && content.documentNumber !== null
      && <TextCell>{ `${ content.documentNumber }` }</TextCell>
  },
  {
    title: 'Fiscal Date',
    id: 13,
    type: 'no-wrap',
    style: {
      width: 100,
      flexShrink: 0
    },
    component: ({ content }) =>
      content.fiscalDate !== undefined
      && content.fiscalDate !== null
      && <TextCell>{ `${ content.fiscalDate }` }</TextCell>
  },
  {
    title: 'Import Profile',
    id: 14,
    type: 'greedy',
    component: ({ content }) =>
      content.profileName !== undefined
      && content.profileName !== null
      && <TextCell>{ `${ content.profileName }` }</TextCell>
  },
  {
    title: 'Vendor Number',
    id: 15,
    style: {
      width: 100,
      flexShrink: 0
    },
    component: ({ content }) =>
      content.vendorNumber !== undefined
      && content.vendorNumber !== null
      && <TextCell>{ `${ content.vendorNumber }` }</TextCell>
  },
  {
    title: 'Updated',
    id: 16,
    style: {
      width: 100,
      flexShrink: 0
    },
    component: () => <TextCell />
  }
];

export default columns;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/ViewTransactionsColumns.js